import { cloneDeep } from "lodash";
import { AnyAction } from "redux";
import {
  FETCH_RELATIONSHIP,
  FILTER_RELATIONSHIP,
  FILTER_RELATIONSHIPGHE,
} from "../actions/relationshipGhe";

interface IrelationshipGhe {
  arrayOneRelationShip: any[];
  arraySaude: any[];
  arraySaudeMenu: any[];

}

const initialState: IrelationshipGhe = {
  arrayOneRelationShip: [],
  arraySaude: [],
  arraySaudeMenu: [],

};

export const relationshipGheReducer = (
  state = initialState,
  action: AnyAction
) => {
  switch (action.type) {
    case FETCH_RELATIONSHIP: {
      return {
        ...cloneDeep(state),
        arrayOneRelationShip: action.arrayOneRelationShip,
        arraySaude: action.arraySaude,
        arraySaudeMenu: action.arraySaudeMenu,
      };
    }
    case FILTER_RELATIONSHIP: {
      return {
        ...cloneDeep(state),
        arrayOneRelationShip: action.arrayOneRelationShip,
      };
    }
    case FILTER_RELATIONSHIPGHE: {
      return {
        ...cloneDeep(state),
        arrayOneRelationShip: action.arrayOneRelationShip,
      };
    }
    default: {
      return state;
    }
  }
};
